//The modals component declaration
'use strict';
import angular from 'angular';
import './scripts/ioclusters.directives';
import './scripts/ioclusters.services';

angular.module('ioclusters', ['ioclusters.directives', 'ioclusters.services'])
